import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Validation } from '../validation.interface';
import { Mask } from '../mask.interface';
import { FormControl } from '@angular/forms';

export class CreditCardNumberModel implements Mask, Validation {

  static CREDIT_CARD_NUMBER = 'creditCardNumber';
  static CREDIT_CARD_NUMBER_ERROR_DESCRIPTION = 'Número do cartão de crédito inválido';

  static creditCardNumber(creditCardNumber: FormControl) {
    if (creditCardNumber.value) {
      const _creditCardNumber = creditCardNumber.value.split('_');
      if (_creditCardNumber.length > 1) {
        return { [CreditCardNumberModel.CREDIT_CARD_NUMBER]: true, description: 'Invalid size' };
      }
      return null;
    } else {
      return { [CreditCardNumberModel.CREDIT_CARD_NUMBER]: true, description: 'Invalid field' };
    }
  }

  private creditCardNumberMask = (value: string): (string | RegExp)[] | Function | boolean => {
    if (value.length > 1) {
      if (value[0] === '4' || value[0] === '5') {
        return [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else if (value[0] === '3' && (value[1] === '4' || value[1] === '7')) {
        return [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getValidatorsName(): string {
    return CreditCardNumberModel.CREDIT_CARD_NUMBER;
  }
  getValidatorsRule(): ValidatorFn {
    return CreditCardNumberModel.creditCardNumber;
  }
  getValidatorsErrorDescription(): string {
    return CreditCardNumberModel.CREDIT_CARD_NUMBER_ERROR_DESCRIPTION;
  }
  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.creditCardNumberMask;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/creditCardNumber.model.ts